export const actions = {
  setCandidatesMode({ commit }, mode) {
    commit('SET_CANDIDATES_MODE', mode);
  },
}
